import dashboardAPI from '@/services/API/dashboard'


const fetchDashboards = function({ commit, state}) {
  if(state.outDated){
    commit('SET_LOADING_DASHBOARDS', true);
    dashboardAPI.fetchDashboards()
      .then(dashboards=>{
        commit('SET_DASHBOARDS', dashboards);
        commit('SET_LOADING_DASHBOARDS', false);
      })
  }
};

const setDashboards = function ({commit, state}, dashboards){
  commit('SET_DASHBOARDS', dashboards);
}

const invalidate = function({commit}){
  commit('INVALIDATE_DASHBOARDS');
}

const updateDashboards = function({state, commit}, dashboards){
  commit('SET_DASHBOARDS', dashboards);
  let localDashboards = _.cloneDeep(state.dashboards);
  _.forEach(localDashboards, (d,index)=>{
    d.position = index;
  })
  return dashboardAPI.bulkUpdate(localDashboards)
    .then(()=>{
      commit('SET_DASHBOARDS', localDashboards);
    })
}

const deleteDashboard = function ({state, commit, dispatch}, id){
  dashboardAPI.delete(id)
    .then(()=>{
      // commit('INVALIDATE_DASHBOARDS');
      // dispatch('fetchDashboards');
      commit('DELETE_DASHBOARD', id);
    })
}

const updateTotalElement = function ({ commit }, { uuid, totalElement }) {
  commit('UPDATE_DASHBOARD_TOTAL_ELEMENT', { uuid, totalElement })
}

const addDashboard = function({ commit }, dashboard) {
  commit('ADD_DASHBOARD', dashboard);
}

export default {
  fetchDashboards,
  setDashboards,
  updateDashboards,
  invalidate,
  deleteDashboard,
  updateTotalElement,
  addDashboard
};
